function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core';
import parseTextToHTML from './parseHTML';

const renderHTML = (text = null, TagName = 'div', options = {}) => {
  if (text && (text.$$typeof && String(text.$$typeof) === 'Symbol(react.element)' || Array.isArray(text) && text.some(node => node && String(node.$$typeof) === 'Symbol(react.element)'))) {
    return jsx(TagName, options, text);
  }

  return jsx(TagName, _extends({}, options, {
    dangerouslySetInnerHTML: {
      __html: parseTextToHTML(String(text))
    }
  }));
};

export default renderHTML;